module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a07784032e83fe500c81b64d0585c3b9.png";